import { Controller } from "@hotwired/stimulus"

// Controls sidebar collapse/expand state with localStorage persistence
export default class extends Controller {
  static targets = ["sidebar", "content", "toggleIcon", "logo"]
  static classes = ["collapsed"]

  static values = {
    storageKey: { type: String, default: "sidebar_collapsed" }
  }

  connect() {
    this.loadState()
  }

  toggle() {
    if (this.isCollapsed) {
      this.expand()
    } else {
      this.collapse()
    }
    this.saveState()
  }

  collapse() {
    this.sidebarTarget.classList.add("sidebar-collapsed")
    this.sidebarTarget.classList.remove("lg:w-80")
    this.sidebarTarget.classList.add("lg:w-20")
    this.contentTarget.classList.remove("lg:ml-80")
    this.contentTarget.classList.add("lg:ml-20")
    this.updateToggleIcon(true)
    this.updateLogo(true)
  }

  expand() {
    this.sidebarTarget.classList.remove("sidebar-collapsed")
    this.sidebarTarget.classList.remove("lg:w-20")
    this.sidebarTarget.classList.add("lg:w-80")
    this.contentTarget.classList.remove("lg:ml-20")
    this.contentTarget.classList.add("lg:ml-80")
    this.updateToggleIcon(false)
    this.updateLogo(false)
  }

  updateToggleIcon(collapsed) {
    if (this.hasToggleIconTarget) {
      this.toggleIconTarget.classList.toggle("fa-bars", !collapsed)
      this.toggleIconTarget.classList.toggle("fa-xmark", collapsed)
    }
  }

  updateLogo(collapsed) {
    if (this.hasLogoTarget) {
      this.logoTarget.classList.toggle("hidden", collapsed)
    }
  }

  get isCollapsed() {
    return this.sidebarTarget.classList.contains("sidebar-collapsed")
  }

  saveState() {
    localStorage.setItem(this.storageKeyValue, this.isCollapsed ? "true" : "false")
  }

  loadState() {
    const savedState = localStorage.getItem(this.storageKeyValue)
    if (savedState === "true") {
      this.collapse()
    }
  }
}
